import { firestore } from "../plugins/firebase";
import { CollectionsNames, Fields } from "../definitions/constants";
import Repository, { Commit } from "../models/Repository";
import ApiService from "./ApiService";
import GitConnectionIssues from "../viewModels/response/repository/GitConnectionIssues";
import RepositoryGitInsightRequest from "../viewModels/request/Repository/RepositoryGitInsightRequest";
import RepositoryTeammemberCommit from "../viewModels/response/repository/RepositoryTeammemberCommit";
import { TeammemberRepositoryVM } from "../viewModels/response/repository/TeammemberRepositoryVM";

export default class RepositoryService {
  public static async getList(): Promise<Repository[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/repository`, "")
        .then((result) => {
          if (!result.data) {
            resolve([] as Repository[]);
          } else {
            const retVal = result.data.map((item: any) => {
              const repo = { Id: item.id, ...item } as Repository;
              return repo;
            });
            resolve(retVal);
          }
        })
        .catch((error) => reject(error));
    });
  }

  // Todo: this should be move to azure function
  public static async getCommits(repository: Repository, commitDateRange: Date[] | null = null): Promise<void> {
    let startDate = commitDateRange && commitDateRange.length > 0 ? commitDateRange[0] : null;
    let endDate = commitDateRange && commitDateRange.length > 1 ? commitDateRange[1] : null;
    if (endDate && startDate && startDate > endDate) {
      startDate = commitDateRange ? commitDateRange[1] : null;
      endDate = commitDateRange ? commitDateRange[0] : null;
    }

    const commitsResult = startDate
      ? endDate
        ? await firestore
            .collection(CollectionsNames.Repositories)
            .doc(repository.Id)
            .collection(CollectionsNames.Repositories_Commits)
            .where(Fields.Repositories.Commits.Date, ">=", startDate)
            .where(Fields.Repositories.Commits.Date, "<=", endDate)
            .get()
        : await firestore
            .collection(CollectionsNames.Repositories)
            .doc(repository.Id)
            .collection(CollectionsNames.Repositories_Commits)
            .where(Fields.Repositories.Commits.Date, ">=", startDate)
            .get()
      : await firestore.collection(CollectionsNames.Repositories).doc(repository.Id).collection(CollectionsNames.Repositories_Commits).get();

    if (commitsResult.empty) {
      repository.Commits = [];
    } else {
      repository.Commits = commitsResult.docs.map((commitDoc: any) => {
        return { id: commitDoc.id, ...commitDoc.data() } as Commit;
      });
    }
  }

  public static async fetchRepositoriesManuallyByProjectLeadId(projectLeadId: string): Promise<string> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/repository/FetchManually?projectLeadId=${projectLeadId}`, "")
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static async syncCommitsOfTeamMembersManually(teamMemberIds: string[], fromDate: string, toDate: string) {
    return new Promise((resolve, reject) => {
      ApiService.post(`/repository/SyncCommitsOfTeamMembersManually?fromDateStr=${fromDate}&toDateStr=${toDate}`, teamMemberIds)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static async GitConnectionErrorsForProjectLead(projectLeadId: string, model: RepositoryGitInsightRequest): Promise<GitConnectionIssues[]> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/repository/gitConnectionErrorsForProjectLead/${projectLeadId}`, model)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static async GetCommitListByProjectLead(projectLeadId: string, model: RepositoryGitInsightRequest): Promise<RepositoryTeammemberCommit[]> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/repository/getCommitListByProjectLead/${projectLeadId}`, model)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static async getRepositoriesByTeamMember(): Promise<TeammemberRepositoryVM[]> {
    return new Promise((resolve, reject) => {
      ApiService.get(`/repository/GetByTeamMember`, "")
        .then((result) => {
          if (!result.data) {
            resolve([] as TeammemberRepositoryVM[]);
          } else {
            const retVal = result.data.map((item: any) => {
              const repo = { Id: item.id, ...item } as TeammemberRepositoryVM;
              return repo;
            });
            resolve(retVal);
          }
        })
        .catch((error) => reject(error));
    });
  }

  public static async createAndUpdate(model: TeammemberRepositoryVM): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiService.post(`/repository`, model)
        .then((result) => {
          if (!result.data) {
            resolve({} as TeammemberRepositoryVM);
          } else {
            resolve(result.data);
          }
        })
        .catch((error) => reject(error));
    });
  }

  public static removeRepository(repo: TeammemberRepositoryVM): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ApiService.delete(`/repository?repo_id=${repo.RepositoryId}`)
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }

  public static disableOrEnableTeammemberRepository(repo: TeammemberRepositoryVM): Promise<boolean> {
    return new Promise((resolve, reject) => {
      ApiService.put(`/repository/DisableOrEnableTeammemberRepository?repo_id=${repo.RepositoryId}&teammemberId=${repo.TeammemberId}`, "")
        .then((result) => {
          resolve(result.data);
        })
        .catch((error) => reject(error));
    });
  }
}
